/* silo Help Centre — accordion sibling-close, anchor scroll-spy, hub search filter, feedback widget. */
(function () {
  'use strict';

  if (window.__siloHelpInit) return;
  window.__siloHelpInit = true;

  // ---- Hub search filter ----------------------------------------

  function initHubSearch() {
    var input = document.querySelector('[data-silo-help-search]');
    if (!input) return;
    var cardGroups = Array.prototype.slice.call(document.querySelectorAll('[data-silo-help-cards]'));
    var emptyMsg = document.querySelector('[data-silo-help-search-empty]');

    function apply() {
      var q = input.value.trim().toLowerCase();
      var anyVisible = false;
      cardGroups.forEach(function (group) {
        var cards = group.querySelectorAll('[data-silo-help-card]');
        Array.prototype.forEach.call(cards, function (card) {
          if (!q) {
            card.hidden = false;
            anyVisible = true;
            return;
          }
          var hay = (card.textContent || '').toLowerCase();
          var match = hay.indexOf(q) !== -1;
          card.hidden = !match;
          if (match) anyVisible = true;
        });
      });
      if (emptyMsg) emptyMsg.hidden = anyVisible || !q;
    }

    input.addEventListener('input', apply);
  }

  // ---- FAQ search filter (scoped to hub FAQs section) -----------

  function initFaqSearch() {
    var input = document.querySelector('[data-silo-help-faq-search]');
    if (!input) return;
    var list = document.querySelector('[data-silo-help-faq-list]');
    if (!list) return;
    var emptyMsg = document.querySelector('[data-silo-help-faq-search-empty]');
    var qas = Array.prototype.slice.call(list.querySelectorAll('[data-silo-help-qa]'));
    var topics = Array.prototype.slice.call(list.querySelectorAll('.silo-help-topic'));

    // Cache search text per Q&A so we don't rebuild it on each keystroke.
    qas.forEach(function (qa) {
      qa.__siloSearchText = (qa.textContent || '').toLowerCase();
    });

    function apply() {
      var q = input.value.trim().toLowerCase();
      var anyMatch = false;

      qas.forEach(function (qa) {
        if (!q) {
          qa.hidden = false;
          if (qa.__siloAutoOpened) {
            qa.open = false;
            qa.__siloAutoOpened = false;
          }
          return;
        }
        var match = qa.__siloSearchText.indexOf(q) !== -1;
        qa.hidden = !match;
        if (match) {
          anyMatch = true;
          if (!qa.open) {
            qa.open = true;
            qa.__siloAutoOpened = true;
          }
        } else if (qa.__siloAutoOpened) {
          qa.open = false;
          qa.__siloAutoOpened = false;
        }
      });

      // Hide topic blocks whose Q&As are all hidden.
      topics.forEach(function (topic) {
        var visible = topic.querySelectorAll('[data-silo-help-qa]:not([hidden])');
        topic.hidden = !!q && visible.length === 0;
      });

      if (emptyMsg) emptyMsg.hidden = !q || anyMatch;
    }

    input.addEventListener('input', apply);
  }

  // ---- Accordion: auto-close other Q&As within the same topic --

  function initAccordionGrouping() {
    var topics = document.querySelectorAll('.silo-help-topic');
    Array.prototype.forEach.call(topics, function (topic) {
      var qas = topic.querySelectorAll('.silo-help-qa');
      Array.prototype.forEach.call(qas, function (qa) {
        qa.addEventListener('toggle', function () {
          if (!qa.open) return;
          Array.prototype.forEach.call(qas, function (other) {
            if (other !== qa && other.open) other.open = false;
          });
        });
      });
    });
  }

  // ---- Anchor nav: active-link highlight + mobile select -------

  function initAnchorNav() {
    var nav = document.querySelector('[data-silo-help-anchor-nav]');
    if (!nav) return;

    // Mobile select -> set hash
    var select = nav.querySelector('[data-silo-help-anchor-select]');
    if (select) {
      select.addEventListener('change', function () {
        var value = select.value;
        if (!value) return;
        // Find the topic by id, scroll into view smoothly (CSS scroll-margin-top respects sticky header)
        var id = value.replace(/^#/, '');
        var target = document.getElementById(id);
        if (target) {
          target.scrollIntoView({ behavior: 'smooth', block: 'start' });
          history.replaceState(null, '', value);
        }
        select.value = '';
      });
    }

    // Desktop active-link highlight
    var links = {};
    Array.prototype.forEach.call(nav.querySelectorAll('[data-silo-help-anchor-link]'), function (a) {
      links[a.getAttribute('data-silo-help-anchor-link')] = a;
    });
    if (!('IntersectionObserver' in window)) return;

    var topics = document.querySelectorAll('.silo-help-topic');
    if (!topics.length) return;

    var visible = {};
    var observer = new IntersectionObserver(function (entries) {
      entries.forEach(function (entry) {
        visible[entry.target.id] = entry.isIntersecting;
      });
      // Pick the topmost visible topic as active
      var activeId = null;
      Array.prototype.some.call(topics, function (t) {
        if (visible[t.id]) {
          activeId = t.id;
          return true;
        }
        return false;
      });
      Object.keys(links).forEach(function (id) {
        links[id].classList.toggle('is-active', id === activeId);
      });
    }, { rootMargin: '-15% 0px -70% 0px', threshold: 0 });

    Array.prototype.forEach.call(topics, function (t) { observer.observe(t); });

    // Smooth scroll on pill click (CSS scroll-behavior: smooth on <html> would work too,
    // but we keep the URL hash in sync)
    Object.keys(links).forEach(function (id) {
      links[id].addEventListener('click', function (e) {
        var target = document.getElementById(id);
        if (!target) return;
        e.preventDefault();
        target.scrollIntoView({ behavior: 'smooth', block: 'start' });
        history.replaceState(null, '', '#' + id);
      });
    });
  }

  // ---- Feedback widget -----------------------------------------

  function feedbackStorageKey(id) { return 'silo-help-fb-' + id; }

  function showFeedbackResult(widget, result) {
    var prompt = widget.querySelector('[data-silo-feedback-prompt]');
    var yesEl  = widget.querySelector('[data-silo-feedback-result-yes]');
    var noEl   = widget.querySelector('[data-silo-feedback-result-no]');
    if (prompt) prompt.hidden = true;
    if (yesEl) yesEl.hidden = result !== 'yes';
    if (noEl)  noEl.hidden  = result !== 'no';
  }

  function initFeedback() {
    var widgets = document.querySelectorAll('[data-silo-feedback]');
    Array.prototype.forEach.call(widgets, function (widget) {
      var id = widget.getAttribute('data-silo-feedback');
      if (!id) return;

      // Restore prior state from localStorage
      try {
        var prior = localStorage.getItem(feedbackStorageKey(id));
        if (prior === 'yes' || prior === 'no') {
          showFeedbackResult(widget, prior);
        }
      } catch (_) { /* localStorage may be disabled — ignore */ }

      var yesBtn = widget.querySelector('[data-silo-feedback-yes]');
      var noBtn  = widget.querySelector('[data-silo-feedback-no]');
      if (yesBtn) {
        yesBtn.addEventListener('click', function () {
          showFeedbackResult(widget, 'yes');
          try { localStorage.setItem(feedbackStorageKey(id), 'yes'); } catch (_) {}
        });
      }
      if (noBtn) {
        noBtn.addEventListener('click', function () {
          showFeedbackResult(widget, 'no');
          try { localStorage.setItem(feedbackStorageKey(id), 'no'); } catch (_) {}
        });
      }
    });
  }

  // ---- Anchor nav: match header's hide-on-scroll-down behaviour --

  function initAnchorNavStickyOffset() {
    var nav = document.querySelector('[data-silo-help-anchor-nav]');
    if (!nav) return;
    var lastY = window.pageYOffset || 0;
    var ticking = false;

    function update() {
      var y = window.pageYOffset || 0;
      var scrollingUp = y < lastY;
      // Header reappears on scroll-up — push the anchor nav below it so they
      // don't overlap. On scroll-down, header hides — anchor nav can go to top.
      if (scrollingUp && y > 80) {
        nav.classList.add('is-header-visible');
      } else {
        nav.classList.remove('is-header-visible');
      }
      lastY = y;
      ticking = false;
    }

    window.addEventListener('scroll', function () {
      if (!ticking) {
        window.requestAnimationFrame(update);
        ticking = true;
      }
    }, { passive: true });
  }

  // ---- Image lightbox (expandable step images) -----------------

  var lightboxEl = null;
  var lightboxImg = null;
  var lastFocused = null;

  function ensureLightbox() {
    if (lightboxEl) return lightboxEl;
    lightboxEl = document.createElement('div');
    lightboxEl.className = 'silo-help-lightbox';
    lightboxEl.setAttribute('role', 'dialog');
    lightboxEl.setAttribute('aria-modal', 'true');
    lightboxEl.setAttribute('aria-label', 'Image viewer');
    lightboxEl.innerHTML =
      '<button type="button" class="silo-help-lightbox__close" aria-label="Close image">' +
        '<svg viewBox="0 0 24 24" width="22" height="22" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><line x1="18" y1="6" x2="6" y2="18"/><line x1="6" y1="6" x2="18" y2="18"/></svg>' +
      '</button>' +
      '<img class="silo-help-lightbox__img" alt="" />';
    document.body.appendChild(lightboxEl);
    lightboxImg = lightboxEl.querySelector('.silo-help-lightbox__img');

    lightboxEl.addEventListener('click', function (e) {
      if (e.target === lightboxEl || e.target === lightboxImg ||
          e.target.closest('.silo-help-lightbox__close')) {
        closeLightbox();
      }
    });
    return lightboxEl;
  }

  function openLightbox(src, alt) {
    ensureLightbox();
    // Clear any previously-rendered image so the modal doesn't flash the
    // last viewed image while the new one downloads.
    lightboxImg.removeAttribute('src');
    lightboxImg.alt = alt || '';
    lightboxImg.style.opacity = '0';
    lightboxEl.classList.add('is-open');
    document.body.classList.add('silo-help-lightbox-open');
    lastFocused = document.activeElement;
    var closeBtn = lightboxEl.querySelector('.silo-help-lightbox__close');
    if (closeBtn) closeBtn.focus();
    // Preload the new image, then swap into view.
    var loader = new Image();
    loader.onload = function () {
      lightboxImg.src = src;
      lightboxImg.style.opacity = '1';
    };
    loader.onerror = function () {
      // Still show the broken-image area so the user knows something went wrong.
      lightboxImg.src = src;
      lightboxImg.style.opacity = '1';
    };
    loader.src = src;
  }

  function closeLightbox() {
    if (!lightboxEl) return;
    lightboxEl.classList.remove('is-open');
    document.body.classList.remove('silo-help-lightbox-open');
    // Clear the image so opening the next one doesn't flash this one.
    if (lightboxImg) {
      lightboxImg.removeAttribute('src');
      lightboxImg.style.opacity = '0';
    }
    if (lastFocused && typeof lastFocused.focus === 'function') {
      lastFocused.focus();
    }
  }

  function initLightbox() {
    document.addEventListener('click', function (e) {
      var btn = e.target.closest('[data-silo-help-zoom]');
      if (!btn) return;
      e.preventDefault();
      var src = btn.getAttribute('data-silo-help-zoom-src');
      var alt = btn.getAttribute('data-silo-help-zoom-alt');
      if (src) openLightbox(src, alt);
    });
    document.addEventListener('keydown', function (e) {
      if (e.key === 'Escape' && lightboxEl && lightboxEl.classList.contains('is-open')) {
        closeLightbox();
      }
    });
  }

  // ---- Boot -----------------------------------------------------

  function init() {
    initHubSearch();
    initFaqSearch();
    initAccordionGrouping();
    initAnchorNav();
    initAnchorNavStickyOffset();
    initFeedback();
    initLightbox();
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
